const DebugOverlay = ({ debugMessage }) => {
  if (!debugMessage) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        backgroundColor: "transparent",
        color: "rgba(139, 0, 0, 0.9)",
        padding: "10px",
        borderRadius: "5px",
        fontFamily: "monospace",
        fontSize: "26px",
        whiteSpace: "pre-wrap",
        pointerEvents: "none", // This makes clicks pass through
        zIndex: 9999,
        WebkitTextStroke: "1px black",
        textStroke: "1px black",
        textAlign: "right",
      }}
      dangerouslySetInnerHTML={{ __html: debugMessage }}
    ></div>
  );
};

export default DebugOverlay;
